import bFormInput from './form-input';
import { registerComponents, vueUse } from '../../utils/plugins';

var components = {
  bFormInput: bFormInput,
  bInput: bFormInput
};

var VuePlugin = {
  install: function install(Vue) {
    registerComponents(Vue, components);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-input/index.js
// module id = o6bs
// module chunks = 40